import $http from "@/plugins/axios.js";

export default {
  state: {
    storesCards: null,
    selectStores: null,
  },
  getters: {
    storesCards: (state) => state.storesCards,
    selectStores: (state) => state.selectStores,
  },
  mutations: {
    SET_STORES_CARDS(state, data) {
      data.data.forEach((item) => {
        item.selected = false;
      });
      state.storesCards = data;
    },
    SET_SELECT_STORES(state, data) {
      state.selectStores = data;
    },
  },
  actions: {
    async getStoresCards(
      { dispatch, commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      dispatch("toggleIsLoading", true);

      try {
        const res = await $http.get("/store/store", {
          params: {
            take: payload.take,
            page: payload.page,
            // cards: true,
            // used: true,
            ...(payload.filters.name && { name: payload.filters.name }),
            ...(payload.filters.number && { number: payload.filters.number }),
            ...(payload.filters.tier && { tier: payload.filters.tier }),
          },
        });

        commit("SET_STORES_CARDS", res.data);
      } catch (err) {
        commit("SET_STORES_CARDS", null);
      } finally {
        dispatch("toggleIsLoading", false);
      }
    },

    async getSelectStores(
      { commit },
      payload = { take: 10, page: 1, filters: {} }
    ) {
      try {
        const res = await $http.get("/store/store", {
          params: {
            take: payload.take,
            page: payload.page,
            // cards: true,
            // used: true,
            ...(payload.filters.name && { name: payload.filters.name }),
            ...(payload.filters.number && { number: payload.filters.number }),
            ...(payload.filters.tier && { tier: payload.filters.tier }),
          },
        });

        commit("SET_SELECT_STORES", res.data);
      } catch (err) {
        commit("SET_SELECT_STORES", null);
      }
    },

    async addStoreCards({ dispatch, commit }, payload) {
      dispatch("toggleBtnLoading", true);
      try {
        await $http.post("/store/cards", payload);
        dispatch("pushAlert", {
          alertVariant: "success",
          alertMessage: "تم اضافة البيانات بنجاح",
          duration: 3,
        });
        dispatch("toggleBtnLoading", false);
        return commit;
      } catch (err) {
        console.error(err);
        if (
          err.response.status === 500 ||
          err.response.status === 404 ||
          err.response.status === 400
        ) {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: err.response.data.error.message,
            duration: 3,
          });
        } else {
          dispatch("pushAlert", {
            alertVariant: "danger",
            alertMessage: "خلل في الاتصال حاول مجددا",
            duration: 3,
          });
        }
        dispatch("toggleBtnLoading", false);
        throw err;
      }
    },
  },
};
